<template>
  <v-container fluid class="pa-0">
    <v-card>
      <v-card-title>{{ $t("event.home") }}</v-card-title>
      <v-card-text>
        <v-form v-model="isFormValid">
          <v-row>
            <v-col class="pb-0">{{ $t("event_home.html_styles") }}</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                outlined
                :placeholder="$t('event_home.html_styles')"
                v-model="eventHome.html_styles"
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0">{{ $t("event_home.html_content") }}</v-col>
          </v-row>
          <v-row>
            <v-col>
              <froala
                v-if="showEditor"
                :config="froalaConfig"
                v-model="eventHome.html_content"
              ></froala>
            </v-col>
          </v-row>
          <v-row>
            <v-file-input
              accept="image/*"
              :label="
                $t('event_home.banner') +
                  ' ' +
                  $t('event_home.recommendedBannerSize')
              "
              v-model="eventHome.banner"
            >
              <template v-slot:selection="{ file }">
                <v-img
                  :src="getFileUrl(file)"
                  max-width="250px"
                  max-height="250px"
                ></v-img>
              </template>
            </v-file-input>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                @click="saveEventHome"
                :disabled="!isFormValid"
              >
                {{ $t("save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-row v-if="homeId">
      <v-col>
        <EventHomeFeatureList :home-id="homeId"></EventHomeFeatureList>
      </v-col>
    </v-row>
    <v-row v-if="homeId">
      <v-col>
        <EventMenuFeatureList :home-id="homeId"></EventMenuFeatureList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { useGet } from "feathers-vuex";
import EventHomeFeatureList from "./EventHomeFeatureList";
import EventMenuFeatureList from "./EventMenuFeatureList";
import froalaConfig from "../../froala-config";

export default {
  name: "EventHome",
  components: { EventHomeFeatureList, EventMenuFeatureList },
  setup(props, { root }) {
    const { Event } = root.$FeathersVuex.api;
    const showEditor = ref(false);

    const eventId = computed(() => root.$route.params.eventId);
    const { item: event } = useGet({ model: Event, id: eventId });

    const eventHome = computed(() => {
      return event.value ? event.value.f_home : {
        html_styles: '',
        html_content: '',        
        banner: null
      };
    });

    // Features
    const homeId = computed(() => {
      return eventHome.value && !eventHome.value.__isTemp
        ? eventHome.value.id
        : null;
    });

    const isFormValid = ref(false);

    const saveEventHome = async function() {
      try {
        if (eventHome.value.banner && eventHome.value.banner instanceof File) {
          eventHome.value.banner = {
            src: await root.$uploadFile(eventHome.value.banner)
          }
        } else {
          eventHome.value.banner = null;
        }

        eventHome.value.save().then(() => {
          root.$store.dispatch(
            "showSnackBar",
            root.$t("event_home.save_successful")
          );
        }, root.$handleFeatherError.bind(root));
      } catch (e) {
        root.$handleFeatherError(e);
      }
    };

    return {
      eventHome,
      showEditor,
      getFileUrl: root.$getFileURL,
      homeId,
      isFormValid,
      saveEventHome,
      froalaConfig,
    };
  },
  mounted() {
    setTimeout(() => {
      this.showEditor = true;
    }, 100);
  }
};
</script>
